import refreshTokenQuery from '~/queries/refreshToken.gql';
import { ApolloClient } from 'apollo-client';
import { Auth } from '@nuxtjs/auth-next';

export async function getRefreshedToken(
  auth: Auth,
  apolloClient: ApolloClient<any>,
) {
  // @ts-ignore For some reason it does not know about the refreshToken property https://github.com/nuxt-community/auth-module/issues/1338
  const refreshToken = auth.strategy.refreshToken.get();

  if (refreshToken) {
    try {
      await auth.refreshTokens();
    } catch (error) {
      const response = (error as any).response;
      const regex = /The client associated with this refresh token.*is different than the one sent in the request/i;

      if (
        (response.status && response.status === 403) ||
        (response.data &&
          response.data.error_description &&
          regex.test(response.data.error_description))
      ) {
        const { data } = await apolloClient.query({
          query: refreshTokenQuery,
          variables: {
            refreshToken,
          },
        });

        if (data && data.refreshToken && data.refreshToken.accessToken) {
          // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
          auth.strategy.token.set(data.refreshToken.accessToken);
        }
      }
    }
  }
}
